const navbarConfig = [
    {
      title: 'All Deals',
      path: '/all_deals'
    },
    {
      title: 'My Stakes',
      path: '/my_stakes'
    },
    {
      title: 'My Deals',
      path: '/my_deals'
    }
  ];
  
  export default navbarConfig;